export default "__VITE_ASSET__BIu5XY0R__"